<template><div class="uo-community uo-community-profile">
	<div v-if="!route.path.endsWith('/edit')" id="nav--profile">
		<div class="uo-profile-panel">
		<ProfileHeader class="mb-0" :profile="data.uogorod_users_by_pk" :is-owner="isOwner"/>

		<div v-if="data.uogorod_users_by_pk.experience||data.uogorod_users_by_pk.city?.region?.name" class="pc-profile-context"><span v-if="data.uogorod_users_by_pk.city?.region?.name">{{data.uogorod_users_by_pk.city.region.name}}</span><span v-if="data.uogorod_users_by_pk.experience">Выращивает с {{String(data.uogorod_users_by_pk.experience).slice(0,4)}}</span></div>
		<ProfileFollowCounts/>
		<ProfileTabs :items="links" />
		</div>
		
	</div>

	<NuxtPage :profile="data.uogorod_users_by_pk" :is-onboarding-complete="isOnboardingComplete"/>
</div></template>

<style scoped>
	#nav--profile{min-width:0;}
	.uo-profile-panel{min-width:0;max-width:100%;background:var(--uo-color-surface-card);border:1px solid var(--uo-color-border-default);border-radius:var(--uo-radius-panel);box-shadow:var(--uo-shadow-card);overflow:hidden;}
	.uo-profile-panel :deep(.uo-profile-card){border:0;border-radius:0;box-shadow:none;margin:0;background:transparent;}
	.uo-profile-tabs{min-width:0;max-width:100%;border-top:1px solid var(--uo-color-border-default);border-bottom:0;background:transparent;padding-inline:24px;gap:24px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;}
	.uo-profile-tabs a{flex-shrink:0;border-bottom:2px solid transparent;color:var(--uo-color-text-secondary);font-weight:500;}
	.uo-profile-tabs a:hover{color:var(--uo-color-text-primary);}
	.uo-profile-tabs a.is-current{
		color:var(--uo-color-action-primaryBackground);border-bottom-color:var(--uo-color-action-primaryBackground);font-weight:600;
	}
	@media(max-width:767px){.uo-profile-panel{border-inline:0;border-radius:0;box-shadow:none;}.uo-profile-tabs{padding-inline:16px;gap:20px;}}
.uo-profile-tabs{scrollbar-width:none;-ms-overflow-style:none;}
.uo-profile-tabs::-webkit-scrollbar{display:none;width:0;height:0;}
.pc-tab-count{font-size:14px;font-weight:400;color:var(--uo-color-text-secondary);margin-left:8px;}
</style>

<script setup>
definePageMeta({key:route=>'profile-'+String(route.params.id)});
import '~/assets/css/community.css';
import '~/assets/css/profile-community.css';
	import ProfileHeader from '~/components/Profile/Header.vue';
	

	import { useGetProfileQuery } from '~/composables/urql';

	const { HOST_BASE } = useRuntimeConfig().public;
	const client = useUser();

	// TODO перетащить подписчиков в массив ?
	const route=useRoute();
	const { params: variables } = route;
	const { id } = variables;
 const social=useProfileFollowing(id);await social.ready;provide('profileFollowing',social);
	const isOwner = id  == client.value?.client_id;
 const {data:tabCounts,refresh:refreshCounts}=await useFetch('/api/profiles/'+id+'/counts');
 watch(()=>route.path,()=>{refreshCounts();social.refresh();});
 let journalCountTimer;const stopJournalCounts=useNuxtApp().hook('journal:membership-changed',()=>{clearTimeout(journalCountTimer);journalCountTimer=setTimeout(()=>refreshCounts().catch(()=>{}),120)});onBeforeUnmount(()=>{stopJournalCounts();clearTimeout(journalCountTimer)});
 const stopBookmarkCounts=useNuxtApp().hook('post-bookmark:changed',()=>refreshCounts());onBeforeUnmount(stopBookmarkCounts);
 const activeTab=href=>{const target='/profiles'+href,path=route.path.replace(/\/+$/,'');return path===target||(href.endsWith('/gardens')&&path.startsWith(target+'/'));};
	const { data } = await useGetProfileQuery({
		variables: {
			id,
			isOwner
		}
	});

	// FIXME Не обновляется состояние (JOURNAL_PRINT & JOURNAL_WELCOME)
	const isOnboardingComplete = computed(() => data.value.uogorod_users_by_pk.achivments.findIndex(i => i.achivment.id == 'JOURNAL_WELCOME') != -1);

	if(!data.value?.uogorod_users_by_pk)throw createError({statusCode:404,message:'Профиль не найден'});
	const links = computed(() => [
		{
			href: `/${id}`,
			title: 'Профиль',
		},
		{
			href: `/${id}/blog`,
			title: 'Записи',count:tabCounts.value?.posts,

		},
		{
			href: `/${id}/gardens`,
			title: 'Журнал'
		},
		{
			href: `/${id}/grown`,
			title: 'Выращенные сорта',count:tabCounts.value?.grown,

		},
		{
			href: `/${id}/favorite`,
			title: 'Избранное',count:tabCounts.value?.favorites,

		},
		{href:`/${id}/reviews`,title:'Отзывы',count:tabCounts.value?.reviews},
		...(String(client.value?.client_id)===String(id)?[{href:`/${id}/tasks`,title:'Задания'}]:[]),
		{href:`/${id}/statistics`,title:'Статистика'},
		{href:`/${id}/achievements`,title:'Достижения'},
		{href:`/${id}/experiments`,title:'Эксперименты'},
		{
			href: `/${id}/groups`,
			title: 'Сообщества'
		},
		{
			href: `/${id}/records`,
			title: 'Рекорды',count:tabCounts.value?.records,

		}
	]);

	const [ firstName, lastName ] = data.value.uogorod_users_by_pk.name.split(' ');

	useProfileSeo(()=>data.value.uogorod_users_by_pk);
	useSeoMeta({ogType:'profile',ogImage:()=> 'https://uogorod.ru/files/userpic/'+id+'.webp'});
</script>
